<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg" style="font-size: 14px; overflow-y: auto;">
    <h2 class="mt-n3 text-center">Welcome Back</h2>
    <div class="mt-3">
      <p>
        We hope you are enjoying PartnerLists.  We've loved <span class="emphasis">helping you grow</span>
        your business with leads from vendors you already work with.
      </p>
      <p>
        <span class="emphasis">On {{ formatDate(me.membership_last_valid_time) }}</span>, 
        we will charge a membership fee of {{ formatCurrency(me.membership_price_cents) }} 
        to your account. Afterwards, your plan will automatically renew monthly.  This allows us to continue building
        features you need to manage and <span class="emphasis">grow your business</span>.
      </p>
    </div>
    <div><strong><em>Your trial expires in {{ days_left }} days!</em></strong></div>
    <div class="d-flex justify-center mt-6">
      <later-dialog :renewed_on="last_valid_time" />
      <v-btn color="primary" class="ml-3" @click="setupNowClick">
        Add a Card
      </v-btn>
    </div>
    <div class="mt-8">
      Please note: if you don't set up your membership, your trial will expire,
      and you will have 90 days review the leads you've already received.
      You can add a payment method to re-activate your account at any time.
    </div>
    <div class="text-center mt-6">
      <strong>Thank you for using PartnerLists.</strong>
    </div>
    <div class="text-center font-weight-bold mx-n2 mt-2" style="font-size: 18px;">
      <em>Get your vendors working for you today!</em>
    </div>
  </div>
</template>

<script>

import LaterDialog from './LaterDialog'
import { mapMutations } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'ReminderAlert',

  props: ['me'],

  components: { LaterDialog },

  computed: {
    days_left() {
      let now = new Date()
      let expires = new Date(this.me.membership_last_valid_time)
      return Math.ceil((expires - now) / (24*3600*1000))
    },

    last_valid_time() {
      return this.formatDate(this.me.membership_last_valid_time)
    },
  },

  methods: {
    ...mapMutations('alerts', ['SNOOZE']),
    ...formatters,

    setupNowClick() {
      this.SNOOZE('payment_method')
      window.history.replaceState(null, '', '/home')
      this.$router.push({ name: 'billing/new_payment_method' })
    },
  },
}

</script>

<style scoped>
  .emphasis {
    color: green;
    font-weight: bold;
  }
</style>